import { render, staticRenderFns } from "./ChoosePlan.vue?vue&type=template&id=754c0724&scoped=true"
import script from "./ChoosePlan.vue?vue&type=script&setup=true&lang=js"
export * from "./ChoosePlan.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChoosePlan.vue?vue&type=style&index=0&id=754c0724&prod&lang=scss&scoped=true"
import style1 from "./ChoosePlan.vue?vue&type=style&index=1&id=754c0724&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754c0724",
  null
  
)

export default component.exports